import { h, Component } from 'preact';
import dlv from 'dlv';

import CardHeader from '../card-header';

import { trackingProvider, trackEvent, INPUT_KEYS, DIMENSION, EVENT } from '@cube/track';

/** Creates div for taboola js insertion
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'TaboolaJs'
})
export class TaboolaJs extends Component {

	trackClick = (e) => {
		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.componentpath]: dlv(this.props, 'taboolaJsParams.placement'),
			[DIMENSION.linkurl]: dlv(e, 'srcElement.parentNode.parentNode.href'),
			[DIMENSION.contenttitle]: dlv(e, 'srcElement.parentNode.parentNode.title'),
			[DIMENSION.contentprovider]: 'Taboola',
			[DIMENSION.text]: dlv(e, 'srcElement.parentNode.parentNode.target') === '_blank' ? 'Sponsored' : 'Organic'
		});
	};

	componentDidMount() {
		if (this.props.taboolaJsParams && window._taboola) {
			window._taboola.push({
				container: this.props.id,
				...this.props.taboolaJsParams
			});
		}
	}

	shouldComponentUpdate = () => false;

	render({ id, theme, title, titleIcon, class: divClass, qeId, ...rest }) {
		if (rest.taboolaJsParams) delete rest.taboolaJsParams;
		return (
			<div>
				{ title && <CardHeader title={title} theme={theme} titleIcon={titleIcon} />}
				<div onClick={this.trackClick} id={id} class={divClass} qid={qeId} {...rest} />
			</div>
		);
	}
}

export function initializeTaboolaJs(props) {
	window._taboola = window._taboola || [];
	window._taboola.push(props);
}

export function finalizeTaboolaJs() {
	window._taboola.push({ flush: true });
}
